var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoProfileSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#noprofile)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24c1.646 0 3.193-.315 4.642-.944a12.29 12.29 0 0 0 6.42-6.42c.626-1.444.938-2.99.938-4.636s-.313-3.191-.938-4.636a12.244 12.244 0 0 0-2.599-3.827A12.224 12.224 0 0 0 16.63.938C15.18.312 13.634 0 11.987 0 10.357 0 8.82.313 7.37.938a12.224 12.224 0 0 0-3.833 2.599A12.244 12.244 0 0 0 .938 7.364C.312 8.808 0 10.354 0 12s.315 3.191.944 4.636a12.31 12.31 0 0 0 2.599 3.821c1.1 1.1 2.399 1.982 3.827 2.598A11.47 11.47 0 0 0 12 24Zm-.3-10.2a3.513 3.513 0 0 1-1.98-.613 4.246 4.246 0 0 1-1.401-1.618C7.973 10.89 7.8 10.12 7.8 9.262c0-.818.171-1.563.513-2.238A4.223 4.223 0 0 1 9.72 5.407 3.45 3.45 0 0 1 11.7 4.8c.724 0 1.38.202 1.968.607a4.36 4.36 0 0 1 1.407 1.618c.35.674.525 1.42.525 2.237 0 .86-.173 1.632-.519 2.32a4.228 4.228 0 0 1-1.401 1.63c-.588.4-1.248.596-1.98.588Zm.306 8.4a10.43 10.43 0 0 1-2.642-.343 10.658 10.658 0 0 1-2.486-.991A8.954 8.954 0 0 1 4.8 19.29c.438-.65 1.021-1.204 1.749-1.665a8.802 8.802 0 0 1 2.48-1.058 11.64 11.64 0 0 1 2.977-.367c1.05 0 2.038.12 2.964.36.926.241 1.754.592 2.481 1.053A5.78 5.78 0 0 1 19.2 19.29a8.716 8.716 0 0 1-2.065 1.576c-.784.433-1.62.767-2.487.991a10.45 10.45 0 0 1-2.642.343Z",
    fill: "#C5CEE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "noprofile"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProfileSmall);
export default __webpack_public_path__ + "static/media/no-profile-small.04cd698a.svg";
export { ForwardRef as ReactComponent };